import { parse as parseJsonc, printParseErrorCode } from 'jsonc-parser'
import type { ParseError } from 'jsonc-parser'
import type { JsonValue } from '../types'

export function cleanStringify(value: JsonValue): string {
  return JSON.stringify(value, null, 2)
}

/**
 * Parse JSON with comments (JSONC). `//` line and `/* ... *\/` block
 * comments and trailing commas are tolerated. Comments do not survive
 * canvas-side edits (graphToJson → cleanStringify emits plain JSON) and
 * are dropped on save, but they're useful in the editor for authoring.
 */
export function tryParse(text: string): { ok: true; value: JsonValue } | { ok: false; error: string } {
  if (text.trim() === '') return { ok: true, value: {} }
  const errors: ParseError[] = []
  const value = parseJsonc(text, errors, {
    allowTrailingComma: true,
    disallowComments: false,
    allowEmptyContent: true,
  })
  if (errors.length > 0) {
    const first = errors[0]
    return {
      ok: false,
      error: `${printParseErrorCode(first.error)} at offset ${first.offset}`,
    }
  }
  return { ok: true, value: (value ?? {}) as JsonValue }
}
